import { useCustomerTribe } from "@/hooks/useCustomerTribe";
import { useGetCustomer, useGetDetailTribe } from "@/services/api";

export const useFWBMemberStatus = () => {
  const { data: customer } = useGetCustomer();
  const {
    data: customerTribe,
    isPending: isTribePending,
    isFetching: isTribeFetching,
  } = useCustomerTribe();
  // The first fetch is running (v4's isInitialLoading).
  const isTribeLoading = isTribePending && isTribeFetching;
  const tribeId = customerTribe?.tribeId ?? "";
  const { data: tribeDetail, isPending: isDetailLoading } = useGetDetailTribe(
    tribeId,
    {
      query: { enabled: !!tribeId },
    },
  );

  const currentMember = tribeDetail?.memberInfo?.find(
    (member) =>
      member.userId !== undefined &&
      String(member.userId) === String(customer?.customerId),
  );
  const inactiveDays = currentMember?.inactiveDays ?? 0;
  const isAtRiskOfRemoval = !!tribeId && inactiveDays > 0;

  return {
    isAtRiskOfRemoval,
    inactiveDays,
    tribeDiscount: tribeDetail?.tribeDiscountNext ?? 0,
    isLoading: isTribeLoading || (!!tribeId && isDetailLoading),
  };
};
